import { FC, ReactNode, useCallback } from 'react'

import { useUnit } from 'effector-react'

import ArrowLeftIcon from '@/assets/icons/icon-arrow-left.svg'
import CopyIcon from '@/assets/icons/icon-copy.svg'
import { useToast } from '@/components/ui/toast'
import { $fanId } from '@/models/chattingUI/chats/chats.ts'
import { $creatorOFId } from '@/models/creators'

import SparklesIcon from '../../../icons/sparkles.svg'
import { IconButton } from '../../components/icon-button'

interface Props {
  step: 'view' | 'scoring' | 'feedback'
  onBack?: () => void
  children?: ReactNode
}

export const ChatSuggestionsHeader: FC<Props> = ({
  step,
  onBack,
  children,
}) => {
  const creatorOFId = useUnit($creatorOFId)
  const fanId = useUnit($fanId)
  const toast = useToast()

  const handleCopyChatId = useCallback(() => {
    const chatId = `${creatorOFId}:${fanId}`

    navigator.clipboard.writeText(chatId)
    toast.success('Chat ID copied successfully')
  }, [creatorOFId, fanId, toast])

  return (
    <div className="flex items-center w-full">
      <div className="flex items-center gap-1">
        {step !== 'view' && (
          <IconButton
            icon={ArrowLeftIcon}
            onClick={onBack}
            iconClassName="h-4 w-4 text-md"
            tooltip="Back"
          />
        )}
        {step === 'view' && (
          <>
            <SparklesIcon />
            <span className="text-base select-none font-medium bg-clip-text bg-gradient-to-r from-blue-600  to-[#5740D980] text-transparent">
              AICH Alpha
            </span>
          </>
        )}
        <IconButton
          className="ml-2"
          icon={CopyIcon}
          tooltip="Copy Chat ID"
          onClick={handleCopyChatId}
        />
      </div>
      {children}
    </div>
  )
}
